import { render, staticRenderFns } from "./VehiclesTabs.vue?vue&type=template&id=1bad5174&"
import script from "./VehiclesTabs.vue?vue&type=script&lang=js&"
export * from "./VehiclesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports